import http from "@/http-common";

export default class MA301050Service {

	getList (_params) {
		return http.get('/ma/ma301050', { params: _params}).then(res => res.data);
	}

	updateList(_data) {
		//alert("#updateList _data = "+ JSON.stringify(_data));
		return http.patch('/ma/ma301050', JSON.stringify(_data)).then(res => res.data);
	}

	deleteList(_data) {
		return http.delete('/ma/ma301050', {data: JSON.stringify(_data)}).then(res => res.data);
	}

	deleteOneMonth(_params) {
		return http.delete('/ma/ma301050/deleteOneMonth', {params: _params}).then(res => res.data);
	}

	getExcelList (_params) {
		return http.get('/ma/ma301050/getExcelList', { params: _params}).then(res => res.data);
	}

	insertExcelList(_data) {
		return http.post('/ma/ma301050/insertExcelList', _data).then(res => res.data);
	}

}